import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import { ReactComponent as TableSearch } from '@assets/svg/table-search.svg';

interface SearchProps {
  haveResults?: boolean;
}
export const Container = styled.div<SearchProps>`
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow-y: auto;
`;

export const WarningText = styled.h2`
  font-style: normal;
  display: flex;
  flex-direction: row;
  font-weight: normal;
  font-size: 14px;

  color: ${beam.font.error};
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  margin-bottom: 8px;

  .mantine-ActionIcon-root {
    margin-left: -27px;
    margin-right: 7px;
  }
`;

export const Search = styled.input<SearchProps>`
  width: 100%;
  border-radius: ${({ haveResults }) => (haveResults ? '8px 8px 0 0' : '8px')};
  font-size: 14px;
  color: ${beam.font.primary};
  align-items: start;
  padding: 10px 12px 10px 16px;
  border-bottom: ${({ haveResults }) =>
    haveResults ? 'none' : '1px solid #e9edf1'};
  box-sizing: border-box;
  display: flex;
  justify-items: center;
  cursor: auto;
  ///
  flex-direction: row;
  gap: 8px;

  height: 42px;

  /* Neutral/N400 (Borders) */
  border: 1px solid #d8dae5;
  /* borders/light-border */
  flex: 1;
  padding-left: 31px;
  -webkit-appearance: none;
  ::placeholder {
    color: #787878;
  }
  :disabled {
    cursor: default;
  }
`;

export const SearchImg = styled(TableSearch)`
  position: absolute;
  left: 13px;
  z-index: 2;
`;

export const SearchButton = styled.h1`
  color: ${beam.color.primaryBlue};
  right: 6px;
  position: absolute;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  margin-right: 5px;
  cursor: pointer;
  margin-bottom: 0;
`;
export const Close = styled.img`
  cursor: pointer;
  margin-left: -21px;
  margin-right: 7px;
`;
export const LoadingImg = styled.img`
  height: 20px;
  width: 20px;
  margin-left: -25px;
  margin-right: 5px;
`;

export const StyledOption = styled.text`
  display: flex;
  user-select: none;
  align-items: flex-start;
  margin-top: 8px;
  padding: 8px 0;
  padding-left: 24px;
  justify-content: flex-start;
  text-align: start;
  width: 100%;
  cursor: pointer;
  :hover {
    border-radius: 8px;
    background: ${beam.background.hover};
  }
`;
export const ShowOptions = styled.div<SearchProps>`
  display: flex;
  position: absolute;
  top: 40px;
  background: #fff;
  width: 100%;
  flex-direction: column;
  z-index: 9;
  border: ${({ haveResults }) => (haveResults ? '1px solid #e9edf1' : 'none')};
  border-top: none;
  border-radius: 0 0 8px 8px;
`;
export const Div = styled.div`
  position: relative;
  flex-direction: column;
  display: flex;
  height: 40px !important;
`;

export const ImagePlaceholder = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  object-fit: cover;
  background-color: transparent;
  &.defaultImage {
    border: none;
  }
`;
